'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["width"];
import { Alignments } from 'rich-text-lib/constants/alignments';
const ImageLayouts = {
  [Alignments.LEFT]: {
    width: 300,
    margin: '0 10px 10px 0',
    command: 'JustifyLeft'
  },
  [Alignments.CENTER]: {
    width: 600,
    margin: '0 auto',
    command: 'JustifyCenter'
  },
  [Alignments.RIGHT]: {
    width: 300,
    margin: '0 0 10px 10px',
    command: 'JustifyRight'
  },
  [Alignments.NONE]: {
    width: null,
    margin: null,
    command: 'JustifyNone'
  }
};
export function getUpdatesForLayout(type, image) {
  const _ref = ImageLayouts[type] || ImageLayouts[Alignments.NONE],
    {
      width
    } = _ref,
    layoutOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
  let newWidth;
  let newHeight;
  if (width) {
    const aspectRatio = image.height / image.width;
    newWidth = Math.min(width, image.naturalWidth);
    newHeight = newWidth * aspectRatio;
  } else {
    newWidth = image.naturalWidth;
    newHeight = image.naturalHeight;
  }
  return Object.assign({}, layoutOptions, {
    width: newWidth,
    height: newHeight
  });
}